export const PluginConfigVersionList = ["2024-05-05", "2023-08-20"] as const;
export type PluginConfigVersion = (typeof PluginConfigVersionList)[number];
